import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, setToken } from "@/lib/api";

const AuthCtx = createContext(null);
export const STAFF_ROLES = ["owner", "workshop_manager", "service_advisor", "technician", "inventory", "accounts"];

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data.user)).catch(() => setUser(null)).finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setToken(r.data.access_token);
    setUser(r.data.user);
    return r.data.user;
  }, []);

  const register = useCallback(async (payload) => {
    const r = await api.post("/auth/register", payload);
    setToken(r.data.access_token);
    setUser(r.data.user);
    return r.data.user;
  }, []);

  const logout = useCallback(async () => {
    await api.post("/auth/logout").catch(() => {});
    setToken(null);
    setUser(null);
  }, []);

  const isStaff = !!user?.roles?.some((r) => STAFF_ROLES.includes(r));
  const isAdmin = !!user?.roles?.some((r) => ["owner", "workshop_manager"].includes(r));

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, login, register, logout, isStaff, isAdmin }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
